/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".align[_ngcontent-%COMP%] {\n  text-align: center; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi91c3Ivc3JjL2FwcC9zcmMvYXBwL29mZmljaWFscy9jb21wb25lbnRzL2Jvb3RzdHJhcC1vZmZpY2lhbHMvYm9vdHN0cmFwLW9mZmljaWFscy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGtCQUFrQixFQUFBIiwiZmlsZSI6InNyYy9hcHAvb2ZmaWNpYWxzL2NvbXBvbmVudHMvYm9vdHN0cmFwLW9mZmljaWFscy9ib290c3RyYXAtb2ZmaWNpYWxzLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmFsaWdue1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG4iXX0= */"];
export { styles as styles };
